import { Button, CardBody, Col, Row } from "reactstrap";
import { LabelText } from "../Utils/Input";
import InputField from "../Utils/InputField";
import CommonDateTimePicker from "../Utils/CommonDateTimePicker";
import moment from "moment";

export const DateAndAttributeDetails = ({ values, setStartDate, setFieldTouched, setFieldValue, initialValues, startDate, selectedOffer, setFormData, formData }) => {
    const dateFormat = localStorage.getItem("dateFormat") || "DD MMM YYYY";
    return (
        <>
            <Col lg={3} md={4} sm={12} className='mb-3'>
                <div>
                    <LabelText htmlFor={'subscriptionStartsOn'} displayText={'Subscription Starts On'} />
                    <LabelText
                        htmlFor={"subscriptionStartsOn"}
                        classLabelName={`d-block ms-0 rv-sub-label rv-label-muted `}
                        displayText={
                            dateFormat
                        }
                    />
                    <CommonDateTimePicker
                        views={['year', 'month', 'day']}
                        value={values.subscriptionStartsOn || initialValues.subscriptionStartsOn}
                        className={`form-control`}
                        handleChange={(selectedDates) => {
                            setStartDate(selectedDates)
                            setFieldTouched('subscriptionStartsOn', false);
                            setFieldValue('subscriptionStartsOn', selectedDates)
                        }}
                        name={"subscriptionStartsOn"}
                        format={dateFormat}
                    />
                </div>
            </Col>
            <Col lg={3} md={4} sm={12} className='mb-3 mb-md-0'>
                <div>
                    <LabelText htmlFor={'subscriptionEndsOn'} displayText={'Subscription Ends On'} />
                    <LabelText
                        htmlFor={"subscriptionEndsOn"}
                        classLabelName={`d-block ms-0 rv-sub-label rv-label-muted `}
                        displayText={
                            dateFormat
                        }
                    />
                    <CommonDateTimePicker
                        views={['year', 'month', 'day']}
                        value={values.subscriptionEndsOn || initialValues.subscriptionEndsOn}
                        handleChange={(selectedDates) => {
                            setFieldTouched('subscriptionEndsOn', false);
                            setFieldValue('subscriptionEndsOn', selectedDates, false)
                        }}
                        className={`form-control`}
                        format={dateFormat}
                        name={"subscriptionEndsOn"}
                        minDateTime={values.subscriptionStartsOn}
                    />
                </div>
            </Col>
            {/* {selectedOffer?.provisioningAttributes?.length > 0 ?
                <div>
                    <CardBody className='border-bottom'>
                        <h5 className="d-inline ">Provisioning Attributes</h5>
                    </CardBody>
                    <Row lg={12}>
                        <table className="table table-borderless table-nowrap">
                            <thead>
                                <tr>
                                    <th scope="col">Name</th>
                                    <th scope="col">Value</th>
                                    <th scope='col'></th>
                                </tr>
                            </thead>
                            <tbody>
                                {selectedOffer?.provisioningAttributes?.map((attribute, index) => (
                                    <tr>
                                        <td>
                                            <InputField
                                                disabled={true}
                                                name={"name"}
                                                type={"text"}
                                                className={"form-control"}
                                                id={"code"}
                                                value={selectedOffer?.provisioningAttributes[index].name}
                                                handleChange={(e) => setFormData({ ...formData, name: e.target.value })}
                                            />
                                        </td>
                                        <td>
                                            <InputField
                                                name={"value"}
                                                placeholder={"Enter the Value"}
                                                type={"text"}
                                                className={"form-control"}
                                                id={"value"}
                                                value={selectedOffer?.provisioningAttributes[index].value}
                                                handleChange={(e) => setFormData({ ...formData, value: e.target.value })}
                                            />
                                        </td>
                                        <td>
                                            <Button type="button" color="secondary" >
                                                Clear
                                            </Button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </Row>
                </div>
                : null} */}
        </>
    )
}